import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

import StatusBadge from 'components/StatusBadge';
import Table from 'components/Table';
import { payoutsTable as TEXT } from 'locales/en/payout';
import { DAY_MONTH } from 'utils/dateFormat';
import PayoutActions from 'pages/Payouts/PayoutActions';

const PayoutTable = ({ data, company, title, isDetail, ...rest }) => {
  const [activeItem, setActiveItem] = useState(null);
  const toggleActiveItem = (id) => {
    if (activeItem === id) {
      setActiveItem(null);
    } else {
      setActiveItem(id);
    }
  };

  return (
    <>
      {title && (
        <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold mb-5">
          {title}
        </h2>
      )}
      <Table
        titles={[
          TEXT.id,
          TEXT.status,
          TEXT.company,
          { name: TEXT.transactions, class: 'text-center' },
          { name: TEXT.gross, class: 'text-center' },
          { name: TEXT.net, class: 'text-center' },
          { name: TEXT.estArrival, class: 'text-center' },
          { name: TEXT.refundAmt, class: 'text-center' },
          { name: TEXT.transferAmt, class: 'text-center' },
          '',
        ]}
        hasData={!!data.length}
        gridClassName="grid-payouts"
        {...rest}
      >
        {data.map((item, idx) => {
          const dataIndexNumber = data.length - 1 === idx ? 'last' : idx;

          return (
            <Fragment key={item.id}>
              <Link
                data-index-number={dataIndexNumber}
                className="underline text-javelin-gray-dark text-xs py-3 px-5"
                to={`/payouts/${item.id}`}
              >
                {item.id}
              </Link>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 pl-5"
              >
                <StatusBadge status={item.status} className="ml-0" />
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5"
                data-testid={`company-${idx}`}
              >
                {item.company?.name || company || '-'}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 text-center"
              >
                {item.transaction_count}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 text-center font-bold"
              >
                {item.grossAmountToDisplay}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 text-center font-bold"
              >
                {item.amountToDisplay}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 text-center"
              >
                {format(new Date(item.estimated_arrival_date), DAY_MONTH)}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 text-center font-bold"
              >
                {item.debitedAmountToDisplay}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className="text-javelin-gray-dark text-xs py-3 px-5 text-center"
              >
                {item.creditedAmountToDisplay}
              </span>
              {isDetail ? (
                <Link
                  data-index-number={dataIndexNumber}
                  className="text-javelin-gray-light text-xs py-3 px-5 text-right cursor-pointer hover:text-javelin-gray-dark"
                  to={`/payouts/${item.id}`}
                >
                  <FontAwesomeIcon
                    icon={['far', 'eye']}
                    className="fill-current my-auto"
                  />
                </Link>
              ) : (
                <span
                  data-index-number={dataIndexNumber}
                  className="text-javelin-gray-dark text-xs relative py-3 text-right pr-5"
                >
                  <PayoutActions
                    onClickOpen={() => toggleActiveItem(item.id)}
                    isOpen={activeItem === item.id}
                    onClose={() => setActiveItem(null)}
                    payoutId={item.id}
                    position={idx <= data.length - 4 ? 'bottom' : 'top'}
                  />
                </span>
              )}
            </Fragment>
          );
        })}
      </Table>
    </>
  );
};

PayoutTable.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
  company: PropTypes.string,
};
PayoutTable.defaultProps = {
  data: [],
  title: TEXT.title,
  company: '-',
};
export default PayoutTable;
